module.exports = __webpack_public_path__ + "h5/img/applystore.728616ab.jpg";